import { useFormContext } from 'react-hook-form';
import { Select } from 'app/agriculture/forms/components/Select/Select';
import { TaskPriorityDef } from 'app/agriculture/queries/tasks/types/TaskPriority';
import { primaryColourMain, secondaryColourMain } from 'app/agriculture/material';
import { Dot } from 'app/agriculture/components/Dot';

export function TaskPriorityDropdown() {
    const formController = useFormContext();

    return (
        <Select
            fieldName="priority"
            noun="Priority"
            options={TaskPriorityDef.map((priority) => ({
                name: priority,
                id: priority,
                startAdornment: (
                    <Dot colour={priority == 'Normal' ? primaryColourMain : secondaryColourMain} />
                ),
            }))}
            formController={formController}
        />
    );
}
